import React from 'react';
export default function Sidebar(_ref) {
  var appProps = _ref.appProps,
    sidebarContent = _ref.sidebarContent;
  return /*#__PURE__*/React.createElement("div", {
    className: "sidebar"
  }, sidebarContent.map(function (sidebarElement, index) {
    if (!sidebarElement.hidden) {
      return /*#__PURE__*/React.createElement("div", {
        key: index,
        className: "sidebar-element ".concat(sidebarElement.isDelete ? 'delete' : '', " ").concat(!sidebarElement.isDelete && window.location.pathname === sidebarElement.path ? 'active' : ''),
        onClick: function onClick() {
          window.location.href = sidebarElement.path;
        }
      }, sidebarElement.title);
    }
  }));
}